import {makeStyles} from '@material-ui/core/styles'
import {ModalBase, Text, TextButton} from '../../1elements'
import Warning from '../../1elements/Icons/js/Warning'
import ButtonLayoutDiv from '../../4layout/ButtonLayoutDiv'
import {useEffect, useState} from 'react'

const BulkImportErrorModal = ({open, setOpen, errorMessagesList}) => {
    const classes = useStyles()
    const [errors, setErrors] = useState([])
    const closeModal = () => {
        setOpen(false)
    }

    const splitMessage = (messageString) => {
        return messageString.split('\n')
    }

    useEffect(()=>{
        let messageArray = []
        for(let i = 0; i < errorMessagesList.length; i++){
            messageArray=messageArray.concat(splitMessage(errorMessagesList[i]))
        }
        setErrors(messageArray)
    }, [errorMessagesList])

    return (
        <ModalBase open={open} setOpen={setOpen} className={classes.root}>
            <div className={classes.textDiv}>
                <Warning className={classes.warningIcon}/>
                <Text type={'adminDashboardTabHeader'}>There were errors in your data.</Text>
            </div>

            <div className={classes.errorTextDiv}>
                <Text type={'errorLogHeader'}>Error Log: </Text>
                <div className={classes.scrollableDiv}>
                    {
                        // errors.map((error, index)=>(
                            <Text type={'errorText'} >{errors}</Text>
                        // ))
                    }
                </div>
            </div>

            <Text>Please update your data file and upload it again.</Text>
            <ButtonLayoutDiv>
                <TextButton clickHandler={closeModal}>Close</TextButton>
            </ButtonLayoutDiv>
        </ModalBase>
    )
}

export default BulkImportErrorModal

const useStyles = makeStyles({
    root: {
        padding: '30px',
    },
    warningIcon: {
        width: '50px',
        marginRight: '20px'
    },
    textDiv: {
        alignItems: 'center',
        display: 'flex',
    },
    errorTextDiv: {
        margin: '50px 10px'
    },
    scrollableDiv: {
        height: '200px',
        overflow: 'auto'
    }
})